import { fetchAuthSession, getCurrentUser } from '@aws-amplify/auth';

// Shared HTTP transport for respondent-side form adapters (trigger + template).
// Attaches Cognito bearer auth when the caller is signed in, and falls back to
// anonymous for public respondents. Errors carry { response: { status, data } }
// so adapters can branch on status (e.g. 404 -> not published).

export async function getAuthHeaders() {
  try {
    const { tokens } = await fetchAuthSession();
    const user = await getCurrentUser();
    if (tokens?.idToken && user?.username) {
      return {
        Authorization: `Bearer ${tokens.idToken.toString()}`,
        'user-id': user.username,
      };
    }
  } catch {
    // Not authenticated — anonymous respondent.
  }
  return {};
}

export async function apiFetch(url, options = {}) {
  const authHeaders = await getAuthHeaders();
  const res = await fetch(url, {
    ...options,
    headers: { ...authHeaders, ...(options.headers || {}) },
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    const err = new Error(body.error || `Request failed: ${res.status}`);
    err.response = { status: res.status, data: body };
    throw err;
  }
  return res.json();
}
